import { FaEnvelope, FaFacebook, FaGlobe, FaLinkedinIn, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import './Footer.css';

const Footer = ({ user, setLoginOpen }) => {

    return (
        <div className="bg-dark text-white footer d-block pb-5 pb-md-0">
            <div className="container col-12 d-flex flex-wrap justify-content-evenly py-2">
                <div className="col-12 col-md-6 col-lg-3 pe-3 pe-md-5 pe-lg-0 mt-2 mt-md-0" style={{ textAlign: "justify" }}>
                    <img alt="logo-white" className="pe-3 pb-1" style={{ height: 120, width: 120, float: "left", objectFit: "contain" }} src="/assets/images/logo-white.png" />
                    <h5>Thrift Store Nepal</h5>
                    <p className="small text-gray">Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal). Search for your best matching thrift item according to different category and criteria. </p>
                </div>
                <div className="d-block col-12 col-md-6 col-lg-3 ps-0 ps-md-0 ps-lg-5  mt-3 mt-md-0 mb-3 mb-md-0">
                    <h5 >Links</h5>
                    <div className="d-flex flex-column">
                        <Link to="/" className=" text-decoration-none small text-gray link">Home</Link>
                        <Link to="/products" className=" text-decoration-none small text-gray link">Product</Link>
                        <Link to="/categories" className=" text-decoration-none small text-gray link">Categories</Link>
                        {user !== null ?
                            <Link to="/users/myaccount/" className=" text-decoration-none small text-gray link">Users</Link> :
                            <>
                                <div onClick={() => { setLoginOpen(true, '1'); }} className=" text-decoration-none small text-gray link cursor-pointer">Login</div>
                                <div onClick={() => { setLoginOpen(true, '2'); }} className=" text-decoration-none small text-gray link cursor-pointer">Sign Up</div>
                            </>}

                        <Link to="/about-us" className=" text-decoration-none small text-gray link">About Us</Link>
                        <Link to="/terms-and-conditions" className=" text-decoration-none small text-gray link">Terms and Conditions</Link>
                        <Link to="/privacy-policy" className=" text-decoration-none small text-gray link">Privacy Policy</Link>
                        <a target="_blank" rel="noopener noreferrer" href="https://everesttechnologies.com.np/#contact" className="text-decoration-none small text-gray link">Contact Us</a>
                    </div>
                </div>
                <div className="d-none d-md-block col-12 col-md-6 col-lg-3  ps-0  mt-2 mt-md-0">
                    <h5 >Connect</h5>
                    <a rel="noreferrer" target="_blank" className="text-gray link text-decoration-none d-flex" href="https://www.facebook.com/NepalThriftStore">
                        <FaFacebook size={25} />
                        <p className="ms-2 small">@NepalThriftStore</p>
                    </a>
                    <a rel="noreferrer" target="_blank" className="text-gray link text-decoration-none d-flex" href="mailto: info@thirftstorenepal.com">
                        <FaEnvelope size={25} />
                        <p className="ms-2 small">info@thirftstorenepal.com</p>
                    </a>
                    <a rel="noreferrer" target="_blank" className="text-gray link text-decoration-none d-flex" href="https://www.linkedin.com/company/76092077">
                        <FaLinkedinIn size={25} />
                        <p className="ms-2 small">Thrift Store Nepal</p>
                    </a>
                    <div className=" d-flex flex-column ml-0 pl-6 mt-3 mt-md-0 mb-3 mb-md-0">
                        <h5 className="mt-3">Download App</h5>
                        <div className="row">
                            <a rel="noreferrer" target="_blank" href="https://apps.apple.com/np/app/thrift-store-nepal/id6475174840">
                                <img alt="app-store" src="/assets/images/app-store.svg" style={{
                                    objectFit: "cover",
                                    width: 150,
                                    height: 50,
                                }} />
                            </a>
                        </div>
                        <div className="row">
                            <a rel="noreferrer" target="_blank" href="https://play.google.com/store/apps/details?id=com.thriftstorenepal">
                                <img alt="app-store" src="/assets/images/play-store.svg" style={{
                                    objectFit: "cover",
                                    width: 150,
                                    height: 50,
                                }} />
                            </a>
                        </div>


                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3  ps-0  mt-2 mt-md-0">
                    <h5 >Contact Us</h5>
                    <a rel="noreferrer" target="_blank" href="https://everesttechnologies.com.np" className="d-flex mb-2 text-gray link text-decoration-none">
                        <img alt="et-logo" src="/assets/images/et-logo.png" style={{ height: 50, width: 50, objectFit: "contain" }} />
                        <p className="my-auto ms-2">Everest Technologies</p>
                    </a>
                    <div className="d-flex mb-2 text-gray">
                        <FaMapMarkerAlt className="my-auto me-2" />
                        <p className="small my-auto">Siddhartha Chowk, Pokhara</p>
                    </div>
                    <a rel="noreferrer" target="_blank" href="mailto: tech.everest.2021@gmail.com" className="d-flex mb-2 text-gray link text-decoration-none">
                        <FaEnvelope className="my-auto me-2" />
                        <p className="small my-auto">tech.everest.2021@gmail.com</p>
                    </a>
                    <a rel="noreferrer" target="_blank" href="https://everesttechnologies.com.np" className="d-flex mb-2 text-gray link text-decoration-none">
                        <FaGlobe className="my-auto me-2" />
                        <p className="small my-auto">everesttechnologies.com.np</p>
                    </a>

                </div>
            </div>
            <div className="col-12 text-center p-3 text-gray small pb-5 pb-md-0" style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}>
                © {new Date().getFullYear()} Copyright:
                <a rel="noreferrer" target="_blank" className="text-gray link text-decoration-none" href="https://everesttechnologies.com.np"> Everest Technologies</a>
            </div>
        </div>
    );
}

export default Footer;